import React from 'react';
import { ModifiersPayload } from 'controllers/SearchController/types';
import { FiltersParams } from 'types/params';
import { Group } from '@landr/maestro';
import ActiveFilter from '../components/ActiveFilter';

const getActiveFilter = (
    queryKey: FiltersParams,
    filter: string | null,
    removeFilter: (modifiers: ModifiersPayload[]) => void,
) => {
    if (!filter) {
        return null;
    }

    return (
        <Group.Item key={`filter-${queryKey}-${filter}`}>
            <ActiveFilter
                onClick={() => removeFilter([[queryKey, filter]])}
                filter={filter}
                queryKey={queryKey}
            />
        </Group.Item>
    );
};

export default getActiveFilter;
